document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector(".hero-shot-slider")) {
        import(/* webpackChunkName: "hero-shot-slider" */ "/Features/HeroShot/js/hero-shot-slider.js").then(async (module) => {
            const heroShotSlider = new module.default();
            await heroShotSlider.init();
        });
    }
});
